/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getGlobalLogger } from '@zg-rentals/logger-base';

import pathsManifest from '../../../../pathsManifest';
import RatingAndReviewActions from '../../../../flux/actions/RatingAndReviewActions';
import queryUtil from '../../../../utils/queryUtils';
import ReviewManager from './ReviewManager';

const logger = getGlobalLogger('pages/RatingAndReviewRoute/ManagerCommentPage');

class ManagerCommentPage extends React.Component {
  constructor(props) {
    super(props);
  }

  handleBack = () => {
    const { dispatch, routingLocation } = this.props;

    dispatch(push(pathsManifest.propertyRatingAndReviewManagerPage + routingLocation.search));
  };

  handleNext = () => {
    const { dispatch, routingLocation, propertyManagerReview, propertyManagerRating, tenantType } = this.props;
    const query = queryUtil.parse(routingLocation.search);

    const body = {
      reviews: [
        {
          type: 'PROPERTY_MANAGER',
          rating: propertyManagerRating,
          comments: propertyManagerReview,
          reviewerType: tenantType || 'FUTURE_RESIDENT',
          source: 'WEB',
        },
      ],
      providerListingId: query.providerListingId,
    };

    dispatch(RatingAndReviewActions.submitReview(body)).catch((err) => {
      logger?.error(err, 'error submitting rating/review');
    });

    dispatch(push(pathsManifest.propertyRatingAndReviewSuccessPage + routingLocation.search));
  };

  handleReviewChange = (e) => {
    this.props.dispatch(RatingAndReviewActions.editPropertyManagerReview(e.target.value));
  };

  render() {
    const { propertyManagerRating, propertyManagerReview } = this.props;

    return (
      <div className="ManagerCommentPage">
        <ReviewManager
          onReviewChange={this.handleReviewChange}
          propertyManagerReview={propertyManagerReview}
          propertyManagerRating={propertyManagerRating}
          onBack={this.handleBack}
          onNext={this.handleNext}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  propertyManagerReview: state.ratingAndReview.propertyManagerReview,
  propertyManagerRating: state.ratingAndReview.propertyManagerRating,
  routingLocation: state.router.location,
  tenantType: state.ratingAndReview.tenantType,
});

export default connect(mapStateToProps)(ManagerCommentPage);
